/* Frete grátis Florescer — progresso na sacola, mensagem na PDP, modal de condições.
   Fonte de verdade dos valores: configurações da seção fs-header (Editor do tema).
   Região: CEP informado no carrinho (faixas oficiais dos Correios) ou endereço da
   conta; nunca geolocalização por IP. Sem região, mostra o estado "desconhecida". */
(function () {
  "use strict";
  var cfgEl = document.getElementById("fl-frete-config");
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg.ativo) return;

  var fmt = new Intl.NumberFormat("pt-BR", { style: "currency", currency: cfg.moeda || "BRL" });
  var preencher = function (texto, valor) {
    return String(texto || "").replace(/(\{\{?|\[)\s*valor\s*(\}?\}|\])/g, fmt.format(valor));
  };
  var menorMinimo = function () {
    return Math.min.apply(null, Object.keys(cfg.minimos).map(function (k) { return cfg.minimos[k]; }));
  };

  /* CEP → UF → região (faixas oficiais dos Correios). */
  var REGIOES = {
    sul: ["PR", "SC", "RS"],
    sudeste: ["SP", "RJ", "ES", "MG"],
    "centro-oeste": ["DF", "GO", "MT", "MS"],
    nordeste: ["BA", "SE", "PE", "AL", "PB", "RN", "CE", "PI", "MA"],
    norte: ["PA", "AP", "AM", "RR", "AC", "TO", "RO"]
  };
  function ufPorCep(cep) {
    var n = parseInt(String(cep).replace(/\D/g, "").slice(0, 5), 10);
    if (!isFinite(n)) return null;
    var p3 = Math.floor(n / 100), p2 = Math.floor(n / 1000);
    if (p3 === 689) return "AP";
    if (p3 === 693) return "RR";
    if (p3 === 699) return "AC";
    if (p3 === 690 || p3 === 691 || p3 === 692 || (p3 >= 694 && p3 <= 698)) return "AM";
    if (p3 === 768 || p3 === 769 || p3 === 789) return "RO";
    if (p2 >= 1 && p2 <= 19) return "SP";
    if (p2 >= 20 && p2 <= 28) return "RJ";
    if (p2 === 29) return "ES";
    if (p2 >= 30 && p2 <= 39) return "MG";
    if (p2 >= 40 && p2 <= 48) return "BA";
    if (p2 === 49) return "SE";
    if (p2 >= 50 && p2 <= 56) return "PE";
    if (p2 === 57) return "AL";
    if (p2 === 58) return "PB";
    if (p2 === 59) return "RN";
    if (p2 >= 60 && p2 <= 63) return "CE";
    if (p2 === 64) return "PI";
    if (p2 === 65) return "MA";
    if (p2 >= 66 && p2 <= 68) return "PA";
    if (p2 >= 70 && p2 <= 72) return "DF";
    if (p2 >= 73 && p2 <= 76) return p2 <= 73 && p3 >= 737 ? "GO" : (p2 >= 74 ? "GO" : "DF");
    if (p2 === 77) return "TO";
    if (p2 === 78) return "MT";
    if (p2 === 79) return "MS";
    if (p2 >= 80 && p2 <= 87) return "PR";
    if (p2 >= 88 && p2 <= 89) return "SC";
    if (p2 >= 90 && p2 <= 99) return "RS";
    return null;
  }
  function regiaoPorUf(uf) {
    for (var r in REGIOES) if (REGIOES[r].indexOf(uf) !== -1) return r;
    return null;
  }

  /* Região atual: CEP salvo (localStorage) ou endereço da conta (Liquid). */
  var CHAVE = "fl-frete-cep";
  function regiaoAtual() {
    var cep = null;
    try { cep = localStorage.getItem(CHAVE); } catch (e) {}
    if (cep) { var uf = ufPorCep(cep); if (uf) return regiaoPorUf(uf); }
    if (cfg.cepConta) { var uf2 = ufPorCep(cfg.cepConta); if (uf2) return regiaoPorUf(uf2); }
    return null;
  }

  /* Modal de condições. */
  var modal = document.querySelector("[data-fl-fg-modal]");
  var overlay = document.querySelector("[data-fl-fg-overlay]");
  function abrirModal() {
    if (!modal) return;
    modal.querySelectorAll("[data-fl-fg-min]").forEach(function (el) {
      el.textContent = "a partir de " + fmt.format(cfg.minimos[el.getAttribute("data-fl-fg-min")] || 0);
    });
    modal.hidden = false; overlay.hidden = false;
    document.body.style.overflow = "hidden";
    var fechar = modal.querySelector("[data-fl-fg-close]"); if (fechar) fechar.focus();
  }
  function fecharModal() {
    if (!modal) return;
    modal.hidden = true; overlay.hidden = true;
    document.body.style.overflow = "";
  }
  if (modal) {
    modal.querySelector("[data-fl-fg-close]").addEventListener("click", fecharModal);
    overlay.addEventListener("click", fecharModal);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !modal.hidden) fecharModal(); });
  }
  document.addEventListener("click", function (e) {
    var t = e.target.closest("[data-fl-fg-abrir]");
    if (t) { e.preventDefault(); abrirModal(); }
  });

  /* Mensagem na página de produto. */
  if (cfg.pdp) {
    var alvo = document.querySelector("[data-fl-frete-gratis-pdp]");
    if (alvo) {
      alvo.className = "fl-fg-pdp";
      alvo.innerHTML = "<strong>" + preencher(cfg.textoBarra, menorMinimo()).replace(/\*?$/, "*") + "</strong>" +
        ' <button type="button" data-fl-fg-abrir>' + (cfg.textoLink || "Consulte sua região") + "</button>";
    }
  }

  /* Progresso na sacola: lê o subtotal exibido pela sacola existente (sem competir com ela). */
  if (!cfg.progresso) return;
  var slot = document.querySelector("[data-fl-frete-progresso]");
  if (!slot) return;
  slot.className = "fl-fg";

  function subtotalAtual() {
    var el = document.querySelector("[data-fl-subtotal]");
    if (!el) return null;
    var n = parseFloat(el.textContent.replace(/[^\d,.-]/g, "").replace(/\./g, "").replace(",", "."));
    return isFinite(n) ? n : null;
  }

  function catalogo() {
    var el = document.getElementById("fl-catalogo");
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }

  function recomendacoes(falta) {
    if (!cfg.recomendacoes || falta == null || falta <= 0) return [];
    return catalogo()
      .filter(function (p) { return p.disponivel && p.imagem && p.preco != null; })
      .map(function (p) { return { p: p, v: (p.variantes || []).filter(function (v) { return v.disponivel; })[0] }; })
      .filter(function (x) { return x.v && x.v.preco / 100 >= Math.min(falta * 0.5, 30); })
      .sort(function (a, b) { return Math.abs(a.v.preco / 100 - falta) - Math.abs(b.v.preco / 100 - falta); })
      .slice(0, 3);
  }

  function render() {
    var subtotal = subtotalAtual();
    if (subtotal == null || subtotal <= 0) { slot.innerHTML = ""; slot.hidden = true; return; }
    slot.hidden = false;
    var regiao = regiaoAtual();
    var html = "";
    if (!regiao) {
      html = '<p class="fl-fg__msg">' + preencher(cfg.textoDesconhecida, menorMinimo()) + "</p>" +
        '<form class="fl-fg__cep" data-fl-fg-cep-form><input type="text" inputmode="numeric" autocomplete="postal-code" placeholder="Seu CEP" aria-label="Informe seu CEP" maxlength="9">' +
        '<button type="submit">Consultar</button></form>' +
        '<p class="fl-fg__erro" data-fl-fg-erro hidden>CEP não reconhecido. Confira os números.</p>' +
        '<button type="button" class="fl-fg__link" data-fl-fg-abrir>' + (cfg.textoLink || "Consulte sua região") + "</button>";
    } else {
      var minimo = cfg.minimos[regiao];
      var falta = minimo - subtotal;
      if (falta <= 0) {
        html = '<p class="fl-fg__msg fl-fg__msg--ok"><strong>' + (cfg.textoGanhou || "Você ganhou FRETE GRÁTIS!") + "</strong></p>" +
          '<div class="fl-fg__barra"><div class="fl-fg__fill fl-fg__fill--ok" style="width:100%"></div></div>';
      } else {
        var pct = Math.min(100, Math.round((subtotal / minimo) * 100));
        html = '<p class="fl-fg__msg">' + preencher(cfg.textoFaltam, falta) + "</p>" +
          '<div class="fl-fg__barra" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + pct + '"><div class="fl-fg__fill" style="width:' + pct + '%"></div></div>';
        var recs = recomendacoes(falta);
        if (recs.length) {
          html += '<div class="fl-fg-recs"><h4>Complete seu pedido e ganhe frete grátis</h4>' + recs.map(function (x) {
            return '<div class="fl-fg-recs__item"><img src="' + x.p.imagem + '" alt="" loading="lazy">' +
              '<div><p class="fl-fg-recs__nome">' + x.p.titulo + '</p><p class="fl-fg-recs__preco">' + fmt.format(x.v.preco / 100) + "</p></div>" +
              '<button type="button" class="fl-fg-recs__add" data-fl-fg-add="' + x.v.id + '">+ Adicionar</button></div>';
          }).join("") + "</div>";
        }
      }
    }
    slot.innerHTML = html;
  }

  slot.addEventListener("submit", function (e) {
    var form = e.target.closest("[data-fl-fg-cep-form]");
    if (!form) return;
    e.preventDefault();
    var cep = form.querySelector("input").value;
    var uf = ufPorCep(cep);
    var erro = slot.querySelector("[data-fl-fg-erro]");
    if (!uf) { if (erro) erro.hidden = false; return; }
    try { localStorage.setItem(CHAVE, cep.replace(/\D/g, "")); } catch (err) {}
    render();
  });

  slot.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-fl-fg-add]");
    if (!btn) return;
    btn.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute("data-fl-fg-add")), quantity: 1 }] })
    }).then(function () {
      /* A sacola existente re-renderiza sozinha; o observador abaixo atualiza o progresso. */
      document.dispatchEvent(new CustomEvent("fl:cart-changed"));
    }).catch(function () { btn.disabled = false; });
  });

  /* Atualiza quando o subtotal da sacola muda ou quando a sacola abre. */
  var alvoSubtotal = document.querySelector("[data-fl-subtotal]");
  if (alvoSubtotal && "MutationObserver" in window) {
    new MutationObserver(render).observe(alvoSubtotal, { childList: true, characterData: true, subtree: true });
  }
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-fl-cart-open]")) setTimeout(render, 600);
  });
  document.addEventListener("fl:cart-changed", function () { setTimeout(render, 600); });
  render();
})();
